module.exports = __webpack_public_path__ + "img/bg-loading.2ee70e33.svg";